// extracted by mini-css-extract-plugin
module.exports = {"spinner":"BusyIndicator_spinner__3PYnn"};